
















import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';

import { EIconsBlog } from './types/EIconsBlog';
import { IBlogKategorie } from './types/IBlog';

export default defineComponent({
  props: {
    menu: {
      require: true,
      type: Array as PropType<Array<IBlogKategorie>>,
      default: () => [],
    },
  },
  setup() {
    const menuState = ref(false);

    function openMenu() {
      menuState.value = !menuState.value;
    }

    return {
      menuState,
      openMenu,
      icons: EIconsBlog,
    };
  },
});
